import { jsx as _jsx } from "react/jsx-runtime";
import { styled, Chip as MUIChip, Box } from "@mui/material";
import { convertPxToRem } from "../../../util-functions";
import { BadgeCounter } from "../../Badges/BadgeCounter";
// Non-interactive chip styles
export const StyledStaticChip = styled(MUIChip, {
    shouldForwardProp: (prop) => prop !== "badgeLeftMargin",
})(({ theme, variant, badgeLeftMargin }) => ({
    "&.MuiChip-root": Object.assign(Object.assign({ 
        // TODO: Jess why isn't this color being applied to the outline variants?
        color: theme.palette.primaryBlackText.main, borderRadius: convertPxToRem(12) }, theme.typography.mediumText), { height: convertPxToRem(32), padding: `${convertPxToRem(6)} ${convertPxToRem(12)}`, 
        // TODO: Jess do you know if there's a way to account for border colors in the palette?
        border: variant === "outlined"
            ? `${convertPxToRem(1.5)} solid ${theme.palette.grey05.main}`
            : "none", 
        // TODO: Jess how to apply theme for disabled state outlined vs filled
        "&.Mui-disabled": {
            opacity: 1,
            backgroundColor: variant === "outlined" ? "transparent" : theme.palette.grey02.main,
            color: theme.palette.tertiaryText.main,
            border: variant === "outlined"
                ? `${convertPxToRem(1.5)} solid ${theme.palette.grey04.main}`
                : "none",
        }, 
        // badge width = 20px, add 4px for margin between badge and left chip border
        ".MuiBadge-root": {
            display: "flex",
            alignItems: "center",
            marginLeft: badgeLeftMargin && convertPxToRem(badgeLeftMargin),
        }, ".MuiChip-label": {
            padding: 0,
        } }),
}));
// Filter & Select chip styles
export const StyledInteractiveChip = styled(StyledStaticChip)(({ theme, deleteIcon, icon }) => ({
    "&.MuiChip-root": {
        boxShadow: "none",
        transition: "none",
        paddingRight: deleteIcon && convertPxToRem(8),
        paddingLeft: icon && convertPxToRem(8),
        "&:focus-visible": {
            border: `${convertPxToRem(2)} solid ${theme.palette.primaryBlack.main}`,
        },
        ".MuiChip-deleteIcon": {
            marginLeft: convertPxToRem(4),
            marginRight: 0,
            marginTop: convertPxToRem(2),
            height: convertPxToRem(18),
        },
        ".MuiChip-label": {
            padding: 0,
            marginRight: 0,
            width: "fit-content",
            overflow: "none",
            textOverflow: "none",
        },
        ".MuiChip-icon": {
            marginRight: convertPxToRem(4),
            marginLeft: 0,
            height: convertPxToRem(18),
        },
        ".MuiTouchRipple-root": {
            display: "none",
        },
    },
}));
export const LabelWithBadge = ({ badgeContent, disabled, label, testId, }) => (_jsx(BadgeCounter, Object.assign({ badgeContent: badgeContent, counterLeftPlacement: true, disabled: disabled, variant: "counter", testId: testId && `${testId}-badge-counter` }, { children: _jsx("span", { children: label }) })));
export const ChipStoryContainer = styled(Box)(() => ({
    ".MuiChip-root": {
        marginRight: "1rem",
    },
}));
